import { StoreTypeEnum } from "@/types/product";
import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

const useWarehouseParams = () => {
  const location = useLocation();

  const [id, setId] = useState<string>('')
  const [type, setType] = useState<StoreTypeEnum>(StoreTypeEnum.CODE)
  const [categoryName, setCategoryName] = useState<string>('')
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type = params.get('type');
    const categoryName = params.get('categoryName');
    setId(id ?? '')
    setType(type === '1' ? StoreTypeEnum.CODE : StoreTypeEnum.NUM)
    setCategoryName(categoryName ?? '')
  }, [location.search])

  return { id, type, categoryName }
}

export default useWarehouseParams;